import type { CorrectionKind, StampKind } from '@wf/shared'

// Beschriftung der Korrektur-Arten (Alt-Parität, CORR_ARTEN). Die gültigen Schlüssel kommen aus dem
// geteilten CORRECTION_KINDS — neue Art im Contract erzwingt hier einen Typ-Fehler statt stiller Lücke.
// EINE Wahrheit für MA-Formular (CorrectionRequestForm) und Chef-Posteingang (CorrectionsInbox).
export const CORRECTION_KIND_LABEL: Record<CorrectionKind, string> = {
  kommen_vergessen: 'Kommen vergessen',
  gehen_vergessen: 'Gehen vergessen',
  kommen_aendern: 'Kommen ändern',
  gehen_aendern: 'Gehen ändern',
  pause: 'Pause nachtragen',
  sonstiges: 'Sonstiges',
}

/** Unbekannte/alte kind-Werte aus der DB defensiv beschriften (Server normalisiert auf 'sonstiges'). */
export function correctionKindLabel(kind: string | null): string {
  return (CORRECTION_KIND_LABEL as Record<string, string>)[kind ?? ''] ?? 'Sonstiges'
}

/** Beschriftung der Stempelarten — reiner Text; die Farbe trägt der CSS-Punkt am Chip
 *  (Simon, 08.07.2026: keine Emojis in den Zeiten-Ansichten, clean wie die übrigen Reiter). */
export const STAMP_KIND_LABEL: Record<StampKind, string> = {
  kommen: 'Kommen',
  gehen: 'Gehen',
  pause_start: 'Pause',
  pause_ende: 'Pause-Ende',
}
